export enum RouteConfig {
  Home = "/",
  Login = "/login",
  Editor = "/editor/:articleId",
  Account = "/account",
  Publications = "/publications",
  UpdateProfile = "/publications/settings",
  UpdateEmail = "/updateEmail",
  Support = "/support",
  Privacy = "/privacy",
  Terms = "/terms",
  Setup = "/setup",
  Analytics = "/analytics",
  SyncArticles = "/sync-articles",
  Docs = "/docs",
}
